var render = function () {
  var _vm$attendanceDetails, _vm$attendanceDetails2, _vm$attendanceDetails3, _vm$user, _vm$user2, _vm$user2$department, _vm$user3, _vm$attendanceDetails4, _vm$attendanceDetails5, _vm$attendanceDetails6, _vm$attendanceDetails7, _vm$attendanceDetails8, _vm$attendanceDetails9, _vm$attendanceDetails10, _vm$attendanceDetails11, _vm$attendanceDetails12, _vm$attendanceDetails13, _vm$authUser, _vm$attendanceDetails14, _vm$attendanceDetails15, _vm$authUser2, _vm$attendanceDetails16, _vm$attendanceDetails17, _vm$attendanceDetails18, _vm$attendanceDetails19, _vm$attendanceDetails20, _vm$attendanceDetails21, _vm$attendanceDetails22, _vm$authUser3, _vm$attendanceDetails23, _vm$attendanceDetails24, _vm$attendanceDetails25, _vm$userData, _vm$userData2, _vm$userData2$user, _vm$userData2$user$da, _vm$userData3, _vm$userData3$user, _vm$userData3$user$da, _vm$userData4, _vm$userData4$user, _vm$userData4$user$da, _vm$userData5, _vm$userData5$user, _vm$userData5$user$da, _vm$userData6, _vm$userData6$user, _vm$userData6$user$da, _vm$userData7, _vm$userData7$user, _vm$userData7$user$da, _vm$userData8, _vm$userData8$user, _vm$userData8$user$da, _vm$userData8$user$da2, _vm$userData9, _vm$userData9$user, _vm$userData9$user$da, _vm$userData9$user$da2, _vm$userData10, _vm$userData11, _vm$userData11$user, _vm$userData11$user$d, _vm$userData12, _vm$userData12$user, _vm$userData12$user$d, _vm$userData13, _vm$userData13$user, _vm$userData13$user$d, _vm$userData14, _vm$userData14$user, _vm$userData14$user$d, _vm$userData15, _vm$userData15$user, _vm$userData15$user$d, _vm$userData16, _vm$userData16$user, _vm$userData16$user$d, _vm$userData17, _vm$userData17$user, _vm$userData17$user$d, _vm$userData17$user$d2, _vm$userData18, _vm$userData18$user, _vm$userData18$user$d, _vm$userData18$user$d2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "4",
      "cols": "12"
    }
  }, [_c('b-card', [_c('b-card-text', [_c('div', {
    staticClass: "text-right"
  }, [_c('b-badge', {
    attrs: {
      "variant": _vm.statusVariant((_vm$attendanceDetails = _vm.attendanceDetails) === null || _vm$attendanceDetails === void 0 ? void 0 : _vm$attendanceDetails.status)
    }
  }, [((_vm$attendanceDetails2 = _vm.attendanceDetails) === null || _vm$attendanceDetails2 === void 0 ? void 0 : _vm$attendanceDetails2.status) === '' ? _c('span', [_vm._v(" Pending ")]) : _c('span', [_vm._v(" " + _vm._s((_vm$attendanceDetails3 = _vm.attendanceDetails) === null || _vm$attendanceDetails3 === void 0 ? void 0 : _vm$attendanceDetails3.status.toUpperCase()) + " ")])])], 1), _c('p', {
    staticClass: "text-uppercase custom-text-disabled"
  }, [_vm._v(" Details ")]), _c('b-list-group', {
    attrs: {
      "flush": ""
    }
  }, [_c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" ID: "), _c('b-badge', {
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v(" " + _vm._s((_vm$user = _vm.user) === null || _vm$user === void 0 ? void 0 : _vm$user.employee_number) + " ")])], 1)]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Department: "), _c('span', {
    staticClass: "text-body-2"
  }, [_vm._v(_vm._s((_vm$user2 = _vm.user) === null || _vm$user2 === void 0 ? void 0 : (_vm$user2$department = _vm$user2.department) === null || _vm$user2$department === void 0 ? void 0 : _vm$user2$department.name))])])]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Name: "), _c('span', {
    staticClass: "text-body-2"
  }, [_vm._v(_vm._s((_vm$user3 = _vm.user) === null || _vm$user3 === void 0 ? void 0 : _vm$user3.name))])])]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Start Time: "), (_vm$attendanceDetails4 = _vm.attendanceDetails) !== null && _vm$attendanceDetails4 !== void 0 && _vm$attendanceDetails4.start_time ? _c('span', {
    staticClass: "text-body-2"
  }, [_vm._v(" " + _vm._s(_vm._f("moment")([(_vm$attendanceDetails5 = _vm.attendanceDetails) === null || _vm$attendanceDetails5 === void 0 ? void 0 : _vm$attendanceDetails5.start_time, "HH:mm:ss"], "LT")) + " ")]) : _c('b-badge', {
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v(" N/A ")])], 1)]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" End Time: "), (_vm$attendanceDetails6 = _vm.attendanceDetails) !== null && _vm$attendanceDetails6 !== void 0 && _vm$attendanceDetails6.end_time ? _c('span', {
    staticClass: "text-body-2"
  }, [_vm._v(_vm._s(_vm._f("moment")([(_vm$attendanceDetails7 = _vm.attendanceDetails) === null || _vm$attendanceDetails7 === void 0 ? void 0 : _vm$attendanceDetails7.end_time, "HH:mm:ss"], "LT")))]) : _c('b-badge', {
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v(" N/A ")])], 1)]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Date: "), _c('span', {
    staticClass: "text-body-2"
  }, [_vm._v(_vm._s(_vm._f("moment")((_vm$attendanceDetails8 = _vm.attendanceDetails) === null || _vm$attendanceDetails8 === void 0 ? void 0 : _vm$attendanceDetails8.requested_date, "ll")))])])]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Description: "), _c('span', {
    staticClass: "text-body-2"
  }, [_vm._v(_vm._s((_vm$attendanceDetails9 = _vm.attendanceDetails) === null || _vm$attendanceDetails9 === void 0 ? void 0 : _vm$attendanceDetails9.description))])])]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Address: "), _c('span', {
    staticClass: "text-body-2"
  }, [_vm._v(_vm._s((_vm$attendanceDetails10 = _vm.attendanceDetails) === null || _vm$attendanceDetails10 === void 0 ? void 0 : _vm$attendanceDetails10.address))])])]), _c('b-list-group-item', [_c('h6', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Contact Person: "), _c('span', {
    staticClass: "text-body-2"
  }, [_vm._v(_vm._s((_vm$attendanceDetails11 = _vm.attendanceDetails) === null || _vm$attendanceDetails11 === void 0 ? void 0 : _vm$attendanceDetails11.contact_person))])])])], 1)], 1)], 1), ((_vm$attendanceDetails12 = _vm.attendanceDetails) === null || _vm$attendanceDetails12 === void 0 ? void 0 : _vm$attendanceDetails12.visiting_completed) === 1 || ((_vm$attendanceDetails13 = _vm.attendanceDetails) === null || _vm$attendanceDetails13 === void 0 ? void 0 : _vm$attendanceDetails13.user_id) === ((_vm$authUser = _vm.authUser) === null || _vm$authUser === void 0 ? void 0 : _vm$authUser.id) && _vm.$permissionAbility(_vm.VISIT_ATTENDANCE_COMPLETED_VISITING, _vm.permissions) ? _c('b-card', [_c('b-card-text', [_c('p', {
    staticClass: "text-uppercase custom-text-disabled"
  }, [_vm._v(" Visited Info ")]), _c('div', {
    staticClass: "text-right"
  }, [((_vm$attendanceDetails14 = _vm.attendanceDetails) === null || _vm$attendanceDetails14 === void 0 ? void 0 : _vm$attendanceDetails14.visiting_completed) === 0 && ((_vm$attendanceDetails15 = _vm.attendanceDetails) === null || _vm$attendanceDetails15 === void 0 ? void 0 : _vm$attendanceDetails15.user_id) === ((_vm$authUser2 = _vm.authUser) === null || _vm$authUser2 === void 0 ? void 0 : _vm$authUser2.id) ? [_c('b-button', {
    attrs: {
      "variant": "warning"
    },
    on: {
      "click": _vm.showModal
    }
  }, [_vm._v("Done Visiting?")])] : _vm._e(), ((_vm$attendanceDetails16 = _vm.attendanceDetails) === null || _vm$attendanceDetails16 === void 0 ? void 0 : _vm$attendanceDetails16.visiting_completed) === 1 ? [_c('b-badge', {
    attrs: {
      "variant": "success"
    }
  }, [_vm._v("Already Visited")])] : _vm._e()], 2), (_vm$attendanceDetails17 = _vm.attendanceDetails) !== null && _vm$attendanceDetails17 !== void 0 && _vm$attendanceDetails17.visiting_completed ? [_c('div', {
    staticClass: "text-right mt-1"
  }, [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }, {
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(113, 102, 240, 0.15)',
      expression: "'rgba(113, 102, 240, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "btn-icon",
    attrs: {
      "variant": "outline-primary",
      "title": (_vm$attendanceDetails18 = _vm.attendanceDetails) === null || _vm$attendanceDetails18 === void 0 ? void 0 : _vm$attendanceDetails18.visiting_remarks
    }
  }, [_c('feather-icon', {
    staticClass: "btn-icon",
    attrs: {
      "icon": "InfoIcon"
    }
  })], 1)], 1), (_vm$attendanceDetails19 = _vm.attendanceDetails) !== null && _vm$attendanceDetails19 !== void 0 && (_vm$attendanceDetails20 = _vm$attendanceDetails19.images) !== null && _vm$attendanceDetails20 !== void 0 && _vm$attendanceDetails20.length ? _c('div', {
    staticClass: "d-flex flex-wrap mt-2"
  }, _vm._l(_vm.attendanceDetails.images, function (image, index) {
    return _c('div', {
      key: index,
      staticClass: "m-1",
      staticStyle: {
        "width": "100px",
        "height": "100px",
        "overflow": "hidden"
      }
    }, [_c('a', {
      attrs: {
        "href": image.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('img', {
      staticClass: "img-thumbnail",
      staticStyle: {
        "width": "100%",
        "height": "100%",
        "object-fit": "cover"
      },
      attrs: {
        "src": image.url,
        "alt": "Attachment"
      }
    })])]);
  }), 0) : _vm._e()] : _vm._e()], 2)], 1) : _vm._e()], 1), _c('b-col', {
    attrs: {
      "lg": "8",
      "cols": "12"
    }
  }, [_c('b-card', [((_vm$attendanceDetails21 = _vm.attendanceDetails) === null || _vm$attendanceDetails21 === void 0 ? void 0 : _vm$attendanceDetails21.visiting_completed) === 0 && ((_vm$attendanceDetails22 = _vm.attendanceDetails) === null || _vm$attendanceDetails22 === void 0 ? void 0 : _vm$attendanceDetails22.user_id) === ((_vm$authUser3 = _vm.authUser) === null || _vm$authUser3 === void 0 ? void 0 : _vm$authUser3.id) && _vm.isTodayRequestedDate ? [!_vm.isLoading ? _c('div', {
    staticClass: "d-flex w-100 justify-content-end mb-1"
  }, [(_vm$attendanceDetails23 = _vm.attendanceDetails) !== null && _vm$attendanceDetails23 !== void 0 && _vm$attendanceDetails23.show_check_in ? _c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }, {
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom.v-success",
      modifiers: {
        "hover": true,
        "bottom": true,
        "v-success": true
      }
    }],
    staticClass: "btn-icon rounded-circle mr-1",
    attrs: {
      "id": "tooltip-check-out",
      "variant": "success",
      "title": "Check In",
      "size": "sm"
    },
    on: {
      "click": _vm.getLocationAndCheckIn
    }
  }, [_c('feather-icon', {
    attrs: {
      "size": "21",
      "icon": "ClockIcon"
    }
  })], 1) : _c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }, {
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom.v-danger",
      modifiers: {
        "hover": true,
        "bottom": true,
        "v-danger": true
      }
    }],
    staticClass: "btn-icon rounded-circle mr-1",
    attrs: {
      "id": "tooltip-check-out",
      "variant": "danger",
      "title": "Check Out",
      "size": "sm"
    },
    on: {
      "click": _vm.getLocationAndCheckOut
    }
  }, [_c('feather-icon', {
    attrs: {
      "size": "21",
      "icon": "CheckCircleIcon"
    }
  })], 1)], 1) : [_c('div', {
    staticClass: "d-flex w-100 justify-content-end mb-1"
  }, [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "btn-icon rounded-circle mr-1",
    attrs: {
      "variant": "primary",
      "size": "sm",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])], 1)], 1)]] : _vm._e(), _c('div', [((_vm$attendanceDetails24 = _vm.attendanceDetails) === null || _vm$attendanceDetails24 === void 0 ? void 0 : _vm$attendanceDetails24.visiting_completed) === 1 && ((_vm$attendanceDetails25 = _vm.attendanceDetails) === null || _vm$attendanceDetails25 === void 0 ? void 0 : _vm$attendanceDetails25.status) === 'pending' && (_vm.checkApprovePermission(_vm.attendanceDetails) || _vm.checkRejectPermission(_vm.attendanceDetails)) ? _c('div', {
    staticClass: "d-flex justify-content-end mb-2"
  }, [_vm.checkRejectPermission(_vm.attendanceDetails) ? _c('span', {
    staticClass: "mr-1",
    on: {
      "click": function click($event) {
        return _vm.rejectModalOpen(_vm.attendanceDetails);
      }
    }
  }, [_c('button', {
    staticClass: "cursor-pointer btn btn-danger"
  }, [_vm._v("Reject")])]) : _vm._e(), _vm.checkApprovePermission(_vm.attendanceDetails) ? _c('span', {
    on: {
      "click": function click($event) {
        return _vm.onApprove(_vm.attendanceDetails);
      }
    }
  }, [_c('button', {
    staticClass: "cursor-pointer btn btn-success"
  }, [_vm._v("Approve")])]) : _vm._e()]) : _vm._e(), _c('vue-good-table', {
    attrs: {
      "style-class": "vgt-table table-custom-style striped",
      "line-numbers": false,
      "rows": _vm.rows,
      "columns": _vm.columns,
      "sort-options": {
        enabled: true,
        multipleColumns: true
      },
      "pagination-options": {
        enabled: true,
        perPage: _vm.pageLength
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        var _props$row, _props$row2, _props$row3, _props$row4, _props$row5, _props$row6, _props$row7, _props$row8, _props$row9, _props$row10, _props$row11, _props$row12, _props$row13, _props$row14, _props$row15, _props$row16, _props$row17, _props$row18;
        return [props.column.field === 'format_worked_minutes' ? _c('span', [props !== null && props !== void 0 && (_props$row = props.row) !== null && _props$row !== void 0 && _props$row.worked_minutes ? [_c('span', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(_vm.formattedTime(props === null || props === void 0 ? void 0 : (_props$row2 = props.row) === null || _props$row2 === void 0 ? void 0 : _props$row2.worked_minutes)) + " ")])] : _vm._e()], 2) : _c('span', [_vm._v(" " + _vm._s(props.formattedRow[props.column.field]) + " ")]), props.column.field === 'format_check_in' ? [props !== null && props !== void 0 && (_props$row3 = props.row) !== null && _props$row3 !== void 0 && _props$row3.check_in ? _c('span', [props !== null && props !== void 0 && (_props$row4 = props.row) !== null && _props$row4 !== void 0 && _props$row4.remarks ? [_c('span', {
          staticClass: "reconciled-time font-weight-bold"
        }, [_vm._v(" " + _vm._s(_vm.formatFnTableCheckIn(props === null || props === void 0 ? void 0 : (_props$row5 = props.row) === null || _props$row5 === void 0 ? void 0 : _props$row5.check_in)) + " ")])] : [_c('span', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(_vm.formatFnTableCheckIn(props === null || props === void 0 ? void 0 : (_props$row6 = props.row) === null || _props$row6 === void 0 ? void 0 : _props$row6.check_in)) + " ")])], _c('br'), _c('b-badge', {
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v("latitude: " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row7 = props.row) === null || _props$row7 === void 0 ? void 0 : _props$row7.check_in_latitude))]), _c('br'), _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("longitude: " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row8 = props.row) === null || _props$row8 === void 0 ? void 0 : _props$row8.check_in_longitude))]), _c('div', {
          staticClass: "map-container"
        }, [_c('iframe', {
          staticStyle: {
            "border": "0"
          },
          attrs: {
            "width": "100%",
            "height": "150",
            "frameborder": "0",
            "allowfullscreen": "",
            "loading": "lazy",
            "src": 'https://www.google.com/maps?q=' + (props === null || props === void 0 ? void 0 : (_props$row9 = props.row) === null || _props$row9 === void 0 ? void 0 : _props$row9.check_in_latitude) + ',' + (props === null || props === void 0 ? void 0 : (_props$row10 = props.row) === null || _props$row10 === void 0 ? void 0 : _props$row10.check_in_longitude) + '&z=15&output=embed'
          }
        })])], 2) : _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v(" N/A ")])] : _vm._e(), props.column.field === 'format_check_out' ? [props !== null && props !== void 0 && (_props$row11 = props.row) !== null && _props$row11 !== void 0 && _props$row11.check_out ? _c('span', [props !== null && props !== void 0 && (_props$row12 = props.row) !== null && _props$row12 !== void 0 && _props$row12.remarks ? [_c('span', {
          staticClass: "reconciled-time font-weight-bold"
        }, [_vm._v(" " + _vm._s(_vm.formatFnTableCheckIn(props === null || props === void 0 ? void 0 : (_props$row13 = props.row) === null || _props$row13 === void 0 ? void 0 : _props$row13.check_out)) + " ")])] : [_c('span', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(_vm.formatFnTableCheckIn(props === null || props === void 0 ? void 0 : (_props$row14 = props.row) === null || _props$row14 === void 0 ? void 0 : _props$row14.check_out)) + " ")])], _c('br'), _c('b-badge', {
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v("latitude: " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row15 = props.row) === null || _props$row15 === void 0 ? void 0 : _props$row15.check_out_latitude))]), _c('br'), _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("longitude: " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row16 = props.row) === null || _props$row16 === void 0 ? void 0 : _props$row16.check_out_longitude))]), _c('div', {
          staticClass: "map-container"
        }, [_c('iframe', {
          staticStyle: {
            "border": "0"
          },
          attrs: {
            "width": "100%",
            "height": "150",
            "frameborder": "0",
            "allowfullscreen": "",
            "loading": "lazy",
            "src": 'https://www.google.com/maps?q=' + (props === null || props === void 0 ? void 0 : (_props$row17 = props.row) === null || _props$row17 === void 0 ? void 0 : _props$row17.check_out_latitude) + ',' + (props === null || props === void 0 ? void 0 : (_props$row18 = props.row) === null || _props$row18 === void 0 ? void 0 : _props$row18.check_out_longitude) + '&z=15&output=embed'
          }
        })])], 2) : _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v(" N/A ")])] : _vm._e()];
      }
    }, {
      key: "pagination-bottom",
      fn: function fn(props) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between flex-wrap"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-0 mt-1"
        }, [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" Showing 1 to ")]), _c('b-form-select', {
          staticClass: "mx-1",
          attrs: {
            "options": ['10', '25', '50', '100', '500']
          },
          on: {
            "input": function input(value) {
              return props.perPageChanged({
                currentPerPage: value
              });
            }
          },
          model: {
            value: _vm.pageLength,
            callback: function callback($$v) {
              _vm.pageLength = $$v;
            },
            expression: "pageLength"
          }
        }), _c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" of " + _vm._s(props.total) + " entries ")])], 1), _c('div', [_c('b-pagination', {
          staticClass: "mt-1 mb-0",
          attrs: {
            "value": 1,
            "total-rows": props.total,
            "per-page": _vm.pageLength,
            "first-number": "",
            "last-number": "",
            "align": "right",
            "prev-class": "prev-item",
            "next-class": "next-item"
          },
          on: {
            "input": function input(value) {
              return props.pageChanged({
                currentPage: value
              });
            }
          },
          scopedSlots: _vm._u([{
            key: "prev-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronLeftIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }, {
            key: "next-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronRightIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }], null, true)
        })], 1)])];
      }
    }])
  })], 1)], 2)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-apply-form",
      "centered": "",
      "title": _vm.modelType == 'editModel' ? 'Visit Attendance Details' : 'Visit Attendance Request',
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "size": "lg"
    },
    on: {
      "hidden": _vm.hiddenApplyModal
    }
  }, [_c('validation-observer', {
    ref: "applyValidation"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.applyFromSubmit($event);
      }
    }
  }, [_c('b-row', {
    staticClass: "justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [(_vm$userData = _vm.userData) !== null && _vm$userData !== void 0 && _vm$userData.user_id ? [_c('b-avatar', {
    attrs: {
      "default": "''",
      "src": ((_vm$userData2 = _vm.userData) === null || _vm$userData2 === void 0 ? void 0 : (_vm$userData2$user = _vm$userData2.user) === null || _vm$userData2$user === void 0 ? void 0 : (_vm$userData2$user$da = _vm$userData2$user.data) === null || _vm$userData2$user$da === void 0 ? void 0 : _vm$userData2$user$da.avatar) === '' ? '/avatar.svg' : (_vm$userData3 = _vm.userData) === null || _vm$userData3 === void 0 ? void 0 : (_vm$userData3$user = _vm$userData3.user) === null || _vm$userData3$user === void 0 ? void 0 : (_vm$userData3$user$da = _vm$userData3$user.data) === null || _vm$userData3$user$da === void 0 ? void 0 : _vm$userData3$user$da.avatar
    }
  }), _c('h4', [_vm._v(_vm._s((_vm$userData4 = _vm.userData) === null || _vm$userData4 === void 0 ? void 0 : (_vm$userData4$user = _vm$userData4.user) === null || _vm$userData4$user === void 0 ? void 0 : (_vm$userData4$user$da = _vm$userData4$user.data) === null || _vm$userData4$user$da === void 0 ? void 0 : _vm$userData4$user$da.name) + " "), _c('b-badge', {
    attrs: {
      "variant": "light-secondary"
    }
  }, [_vm._v(_vm._s((_vm$userData5 = _vm.userData) === null || _vm$userData5 === void 0 ? void 0 : (_vm$userData5$user = _vm$userData5.user) === null || _vm$userData5$user === void 0 ? void 0 : (_vm$userData5$user$da = _vm$userData5$user.data) === null || _vm$userData5$user$da === void 0 ? void 0 : _vm$userData5$user$da.employee_number))])], 1), _c('a', {
    staticClass: "font-small-2 font-weight-bold",
    attrs: {
      "href": 'mailto:' + (((_vm$userData6 = _vm.userData) === null || _vm$userData6 === void 0 ? void 0 : (_vm$userData6$user = _vm$userData6.user) === null || _vm$userData6$user === void 0 ? void 0 : (_vm$userData6$user$da = _vm$userData6$user.data) === null || _vm$userData6$user$da === void 0 ? void 0 : _vm$userData6$user$da.email) || '')
    }
  }, [_vm._v(" " + _vm._s((_vm$userData7 = _vm.userData) === null || _vm$userData7 === void 0 ? void 0 : (_vm$userData7$user = _vm$userData7.user) === null || _vm$userData7$user === void 0 ? void 0 : (_vm$userData7$user$da = _vm$userData7$user.data) === null || _vm$userData7$user$da === void 0 ? void 0 : _vm$userData7$user$da.email) + " ")]), _vm._v(" "), _c('br'), _c('b-badge', {
    attrs: {
      "variant": "light-primary"
    }
  }, [_vm._v(" " + _vm._s((_vm$userData8 = _vm.userData) === null || _vm$userData8 === void 0 ? void 0 : (_vm$userData8$user = _vm$userData8.user) === null || _vm$userData8$user === void 0 ? void 0 : (_vm$userData8$user$da = _vm$userData8$user.data) === null || _vm$userData8$user$da === void 0 ? void 0 : (_vm$userData8$user$da2 = _vm$userData8$user$da.department) === null || _vm$userData8$user$da2 === void 0 ? void 0 : _vm$userData8$user$da2.name) + " ")]), _vm._v(" "), _c('br'), _c('b-badge', {
    attrs: {
      "variant": "light-primary"
    }
  }, [_vm._v(" " + _vm._s((_vm$userData9 = _vm.userData) === null || _vm$userData9 === void 0 ? void 0 : (_vm$userData9$user = _vm$userData9.user) === null || _vm$userData9$user === void 0 ? void 0 : (_vm$userData9$user$da = _vm$userData9$user.data) === null || _vm$userData9$user$da === void 0 ? void 0 : (_vm$userData9$user$da2 = _vm$userData9$user$da.designation) === null || _vm$userData9$user$da2 === void 0 ? void 0 : _vm$userData9$user$da2.name) + " ")])] : _vm._e()], 2)])], 1), _c('b-form-group', {
    attrs: {
      "label": "Visit Attendance Date*"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "date",
      "vid": "requested_date",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('flat-pickr', {
          staticClass: "form-control",
          attrs: {
            "placeholder": "Select Date",
            "state": errors.length > 0 ? false : null,
            "id": "attendance-date",
            "disabled": _vm.applyEmployee && !_vm.selectUserId || _vm.modelType === 'editModel',
            "config": _vm.attendanceDateConfig
          },
          model: {
            value: _vm.attendanceDate,
            callback: function callback($$v) {
              _vm.attendanceDate = $$v;
            },
            expression: "attendanceDate"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Requested Check In*"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "check in",
      "vid": "check_in",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var errors = _ref2.errors;
        return [_c('flat-pickr', {
          staticClass: "form-control",
          attrs: {
            "name": "check-in",
            "id": "check_in",
            "placeholder": "09:00 AM",
            "config": {
              enableTime: true,
              noCalendar: true,
              static: true,
              dateFormat: 'H:i:S',
              altInput: true,
              altFormat: 'h:i K',
              minuteIncrement: 1
            },
            "disabled": !_vm.attendanceDate || _vm.modelType === 'editModel',
            "state": errors.length > 0 ? false : null
          },
          model: {
            value: _vm.checkIn,
            callback: function callback($$v) {
              _vm.checkIn = $$v;
            },
            expression: "checkIn"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Requested Check Out*"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "check out",
      "vid": "check_out",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var errors = _ref3.errors;
        return [_c('flat-pickr', {
          staticClass: "form-control",
          attrs: {
            "name": "check-out",
            "id": "check_out",
            "placeholder": "06:00 PM",
            "config": {
              enableTime: true,
              noCalendar: true,
              static: true,
              dateFormat: 'H:i:S',
              altInput: true,
              altFormat: 'h:i K',
              minuteIncrement: 1
            },
            "disabled": !_vm.attendanceDate || _vm.modelType === 'editModel',
            "state": errors.length > 0 ? false : null
          },
          model: {
            value: _vm.checkOut,
            callback: function callback($$v) {
              _vm.checkOut = $$v;
            },
            expression: "checkOut"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1), _c('b-form-group', {
    attrs: {
      "label": "Description*",
      "label-for": "description"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "description",
      "vid": "description",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var errors = _ref4.errors;
        return [_c('b-form-textarea', {
          attrs: {
            "id": "description",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Description",
            "rows": "3",
            "disabled": _vm.modelType === 'editModel'
          },
          model: {
            value: _vm.description,
            callback: function callback($$v) {
              _vm.description = $$v;
            },
            expression: "description"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Contact Person",
      "label-for": "contact_person"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "contact person",
      "vid": "contact_person",
      "rules": "required|max:255"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var errors = _ref5.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "name",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Contact Person",
            "disabled": _vm.modelType === 'editModel'
          },
          model: {
            value: _vm.contact_person,
            callback: function callback($$v) {
              _vm.contact_person = $$v;
            },
            expression: "contact_person"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Address*",
      "label-for": "address"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "address",
      "vid": "address",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref6) {
        var errors = _ref6.errors;
        return [_c('b-form-textarea', {
          attrs: {
            "id": "address",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Address",
            "rows": "3",
            "disabled": _vm.modelType === 'editModel'
          },
          model: {
            value: _vm.address,
            callback: function callback($$v) {
              _vm.address = $$v;
            },
            expression: "address"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _vm.modelType == 'editModel' ? [_c('b-form-group', {
    class: _vm.checkApprovePermission(_vm.userData) ? 'required-label' : '',
    attrs: {
      "label": "Remarks",
      "label-for": "remarks"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "remarks",
      "vid": "remarks",
      "rules": _vm.checkApprovePermission(_vm.userData) ? 'required' : ''
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref7) {
        var errors = _ref7.errors;
        return [_c('b-form-textarea', {
          attrs: {
            "id": "required-remarks",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Remarks",
            "rows": "3",
            "disabled": !_vm.checkApprovePermission(_vm.userData)
          },
          model: {
            value: _vm.remarks,
            callback: function callback($$v) {
              _vm.remarks = $$v;
            },
            expression: "remarks"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 611707180)
  })], 1)] : _vm._e(), _vm.isApplyFormSubmitLoading ? [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : _vm._e(), !_vm.approveButton && !_vm.isApplyFormSubmitLoading ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])] : _vm._e(), _vm.approveButton && !_vm.isApplyFormSubmitLoading ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "variant": "warning"
    },
    on: {
      "click": _vm.handleApproveClick
    }
  }, [_vm._v(" Approve ")])] : _vm._e()], 2)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-reject-form",
      "centered": "",
      "title": "Reject Request",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "size": "lg"
    },
    on: {
      "hidden": _vm.hiddenRejectModal
    }
  }, [_c('validation-observer', {
    ref: "rejectValidation"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.rejectFromSubmit($event);
      }
    }
  }, [_c('b-row', {
    staticClass: "justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [(_vm$userData10 = _vm.userData) !== null && _vm$userData10 !== void 0 && _vm$userData10.user_id ? [_c('b-avatar', {
    attrs: {
      "default": "''",
      "src": ((_vm$userData11 = _vm.userData) === null || _vm$userData11 === void 0 ? void 0 : (_vm$userData11$user = _vm$userData11.user) === null || _vm$userData11$user === void 0 ? void 0 : (_vm$userData11$user$d = _vm$userData11$user.data) === null || _vm$userData11$user$d === void 0 ? void 0 : _vm$userData11$user$d.avatar) === '' ? '/avatar.svg' : (_vm$userData12 = _vm.userData) === null || _vm$userData12 === void 0 ? void 0 : (_vm$userData12$user = _vm$userData12.user) === null || _vm$userData12$user === void 0 ? void 0 : (_vm$userData12$user$d = _vm$userData12$user.data) === null || _vm$userData12$user$d === void 0 ? void 0 : _vm$userData12$user$d.avatar
    }
  }), _c('h4', [_vm._v(_vm._s((_vm$userData13 = _vm.userData) === null || _vm$userData13 === void 0 ? void 0 : (_vm$userData13$user = _vm$userData13.user) === null || _vm$userData13$user === void 0 ? void 0 : (_vm$userData13$user$d = _vm$userData13$user.data) === null || _vm$userData13$user$d === void 0 ? void 0 : _vm$userData13$user$d.name) + " "), _c('b-badge', {
    attrs: {
      "variant": "light-secondary"
    }
  }, [_vm._v(_vm._s((_vm$userData14 = _vm.userData) === null || _vm$userData14 === void 0 ? void 0 : (_vm$userData14$user = _vm$userData14.user) === null || _vm$userData14$user === void 0 ? void 0 : (_vm$userData14$user$d = _vm$userData14$user.data) === null || _vm$userData14$user$d === void 0 ? void 0 : _vm$userData14$user$d.employee_number))])], 1), _c('a', {
    staticClass: "font-small-2 font-weight-bold",
    attrs: {
      "href": 'mailto:' + (((_vm$userData15 = _vm.userData) === null || _vm$userData15 === void 0 ? void 0 : (_vm$userData15$user = _vm$userData15.user) === null || _vm$userData15$user === void 0 ? void 0 : (_vm$userData15$user$d = _vm$userData15$user.data) === null || _vm$userData15$user$d === void 0 ? void 0 : _vm$userData15$user$d.email) || '')
    }
  }, [_vm._v(" " + _vm._s((_vm$userData16 = _vm.userData) === null || _vm$userData16 === void 0 ? void 0 : (_vm$userData16$user = _vm$userData16.user) === null || _vm$userData16$user === void 0 ? void 0 : (_vm$userData16$user$d = _vm$userData16$user.data) === null || _vm$userData16$user$d === void 0 ? void 0 : _vm$userData16$user$d.email) + " ")]), _vm._v(" "), _c('br'), _c('b-badge', {
    attrs: {
      "variant": "light-primary"
    }
  }, [_vm._v(" " + _vm._s((_vm$userData17 = _vm.userData) === null || _vm$userData17 === void 0 ? void 0 : (_vm$userData17$user = _vm$userData17.user) === null || _vm$userData17$user === void 0 ? void 0 : (_vm$userData17$user$d = _vm$userData17$user.data) === null || _vm$userData17$user$d === void 0 ? void 0 : (_vm$userData17$user$d2 = _vm$userData17$user$d.department) === null || _vm$userData17$user$d2 === void 0 ? void 0 : _vm$userData17$user$d2.name) + " ")]), _vm._v(" "), _c('br'), _c('b-badge', {
    attrs: {
      "variant": "light-primary"
    }
  }, [_vm._v(" " + _vm._s((_vm$userData18 = _vm.userData) === null || _vm$userData18 === void 0 ? void 0 : (_vm$userData18$user = _vm$userData18.user) === null || _vm$userData18$user === void 0 ? void 0 : (_vm$userData18$user$d = _vm$userData18$user.data) === null || _vm$userData18$user$d === void 0 ? void 0 : (_vm$userData18$user$d2 = _vm$userData18$user$d.designation) === null || _vm$userData18$user$d2 === void 0 ? void 0 : _vm$userData18$user$d2.name) + " ")])] : _vm._e()], 2)])], 1), _c('b-form-group', {
    attrs: {
      "label": "Rejection Remarks*",
      "label-for": "rejection_remarks"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Rejection Remarks",
      "vid": "rejection_remarks",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref8) {
        var errors = _ref8.errors;
        return [_c('b-form-textarea', {
          attrs: {
            "id": "rejection_remarks",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Rejection Remarks",
            "rows": "3"
          },
          model: {
            value: _vm.rejectionRemarks,
            callback: function callback($$v) {
              _vm.rejectionRemarks = $$v;
            },
            expression: "rejectionRemarks"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])]], 2)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-complete-visiting-form",
      "centered": "",
      "title": "Complete Visiting Form",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "size": "lg"
    },
    on: {
      "hidden": _vm.hiddenModal
    }
  }, [_c('validation-observer', {
    ref: "applyValidation"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.applyFromSubmit($event);
      }
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Remarks",
      "label-for": "remarks"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "remarks",
      "vid": "remarks",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref9) {
        var errors = _ref9.errors;
        return [_c('b-form-textarea', {
          attrs: {
            "id": "remarks",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Remarks",
            "rows": "3"
          },
          model: {
            value: _vm.complete_visiting_remarks,
            callback: function callback($$v) {
              _vm.complete_visiting_remarks = $$v;
            },
            expression: "complete_visiting_remarks"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": 'Attachment',
      "label-for": "file"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "attachment",
      "vid": "attachment"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref10) {
        var errors = _ref10.errors;
        return [_c('b-form-file', {
          attrs: {
            "id": 'attachment',
            "multiple": "",
            "state": errors.length ? false : null,
            "placeholder": "Choose a file or drop it here...",
            "drop-placeholder": "Drop file here..."
          },
          on: {
            "change": _vm.handleFileChange
          },
          model: {
            value: _vm.file,
            callback: function callback($$v) {
              _vm.file = $$v;
            },
            expression: "file"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _vm.isLoading ? [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])]], 2)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }